import { render, staticRenderFns } from "./DeptSalaryRatioChart.vue?vue&type=template&id=074b3edb&"
import script from "./DeptSalaryRatioChart.vue?vue&type=script&lang=js&"
export * from "./DeptSalaryRatioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports